// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2tLSt","col":"styles_col__M7US5"};